import Descriptions from 'antd/es/descriptions';
import { Button, Checkbox, Progress, Skeleton } from 'antd';
import { useState } from 'react';
import Card from 'antd/es/card';
import { LockFilled } from '@ant-design/icons';
import style from '../ProfileRestyle.module.css';

const fin_receivedMgp = [
  {
    label: 'Программа поддержки',
    children: 'Единая комплексная программа',
    span: '1',
  },
  {
    label: 'Дата получения',
    children: '20.07.2024',
    span: '1',
  },
  {
    label: 'Условия',
    children: 'субсидирование ставки вознаграждения',
    span: '1',
  },
  {
    label: 'Дата завершения',
    children: '20.07.2027',
    span: '1',
  },
];

const fin_available_mgp = [
  {
    label: 'Субсидирование (ДАМУ …)',
    value: 'subsidization',
  },
  {
    label: 'Гарантирование (ДАМУ …)',
    value: 'guarantee',
  },
  {
    label: 'Кредитование',
    value: 'crediting',
  },
  {
    label: 'Лизинг (ФРП, АКК …)',
    value: 'leasing',
  },
];

const nonfin_receivedMgp = [
  {
    label: 'Дата получения',
    children: '05.03.2024',
    span: '1',
  },
  {
    label: 'Тема',
    children: '',
    span: '1',
  },
];

const nonfin_available_mgp = [
  {
    label: 'Отраслевое обучение (best practice)',
    value: 'best_practice',
  },
  {
    label: 'HR, персонал',
    value: 'hr',
  },
  {
    label: 'Обучение пользованием учетными системами (фин. грамотность)',
    value: 'financial_competence',
  },
  {
    label: 'Кооперация',
    value: 'cooperation',
  },
  {
    label: 'Продажи онлайн / офлайн',
    value: 'sales',
  },
];

function CompetitiveLevel() {
  const [agreement, setAgreement] = useState(false);
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      {!agreement && (
        <div
          className={style.competitive_level_mask}
          onClick={() => setShowModal(true)}
        >
          <LockFilled
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '100px',
            }}
          />
          {showModal && (
            <Card className={style.competitive_level_modal}>
              <div className={style.modal_title}>
                Согласие на вступление в реестр получателей МП...
              </div>
              <div className={style.modal_buttons}>
                <Button
                  onClick={() => {
                    setAgreement(true);
                    setShowModal(false);
                  }}
                  className={[style.modal_button, style.yes_button].join(' ')}
                >
                  Да
                </Button>
                <Button
                  className={[style.modal_button, style.no_button].join(' ')}
                >
                  Нет
                </Button>
              </div>
              <div className={style.modal_user_agreement}>
                прочитать <a>Пользовательское соглашение</a>
              </div>
              <div className={style.modal_footer}>
                Предлагается закрепить в НПА данное понятие (поручение ГГ от
                12.09.2023 – создать Единый реестр получателей мер господдержки)
              </div>
            </Card>
          )}
        </div>
      )}
      <div className={style.competitive_level_title}>
        Уровень конкурентоспособности компании: Стабильный (ДВЦ – 2 категория)
      </div>
      <div className={style.competitive_level_wrapper}>
        <div className={style.vertical_text} style={{ background: '#cee6ff' }}>
          Финансовые
        </div>
        <div className={style.competitive_level_block}>
          {!agreement ? (
            <Skeleton />
          ) : (
            <>
              <div className={style.competitive_level_block_title}>
                Выданные меры поддержки
              </div>
              <Descriptions
                items={fin_receivedMgp}
                column={1}
                style={{ marginTop: 10 }}
              />
              <div
                style={{ fweight: '600', margin: '16px 0px', color: 'green' }}
              >
                Исполнение встречных обязательств по Программе поддержки …
              </div>
              <Progress
                percent={15}
                percentPosition={{ align: 'center', type: 'inner' }}
                size={['100%', 20]}
              />
            </>
          )}
        </div>
        <div className={style.competitive_level_block}>
          {!agreement ? (
            <Skeleton />
          ) : (
            <>
              <div className={style.competitive_level_block_title}>
                Доступные меры поддержки
              </div>
              <div className={style.competitive_level_block_subtitle}>
                (выберите инструменты не более 3-х)
              </div>
              <Checkbox.Group
                options={fin_available_mgp}
                style={{ flexDirection: 'column', marginTop: 10 }}
              />
              <Button
                type="primary"
                style={{ display: 'block', marginTop: 16 }}
              >
                Подать заявку
              </Button>
            </>
          )}
        </div>
        <div className={style.vertical_text} style={{ background: '#a1b4ff' }}>
          Нефинансовые
        </div>
        <div className={style.competitive_level_block}>
          {!agreement ? (
            <Skeleton />
          ) : (
            <>
              <div className={style.competitive_level_block_title}>
                Выданные меры поддержки
              </div>
              <div>Сертификат по HR, персонал</div>
              <Descriptions
                items={nonfin_receivedMgp}
                column={1}
                style={{ marginTop: 10 }}
              />
            </>
          )}
        </div>
        <div className={style.competitive_level_block}>
          {!agreement ? (
            <Skeleton />
          ) : (
            <>
              <div className={style.competitive_level_block_title}>
                Доступные меры поддержки
              </div>
              <Checkbox.Group
                options={nonfin_available_mgp}
                style={{ flexDirection: 'column', marginTop: 10 }}
              />
              <Button
                type="primary"
                style={{ display: 'block', marginTop: 16 }}
              >
                Подать заявку
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CompetitiveLevel;
